type HTMLElementEvent<T extends HTMLElement> = Event & {
  target: T;
}

export class ImageLoadingHandler {
  imageObserver: IntersectionObserver;

  createImageObserver() {
    this.imageObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const lazyImage: HTMLImageElement = entry.target as HTMLImageElement;

          if (lazyImage.dataset.status === 'not-loaded'
            || (lazyImage.dataset.src && lazyImage.src !== lazyImage.dataset.src)) {
            lazyImage.addEventListener('load', (event: HTMLElementEvent<HTMLImageElement>) => {
              event.target.classList.add('opacity-1');
            });

            lazyImage.dataset.status = 'loaded';
            lazyImage.src = lazyImage.dataset.src;
          }
        }
      })
    });

    const images = document.querySelectorAll('img[data-src]');
    images.forEach((v: HTMLImageElement) => {
      if (v.dataset.status === 'loaded') return;
      this.imageObserver.observe(v);
    });
  }

  observeThisImage(event: HTMLElementEvent<HTMLImageElement>) {
    this.imageObserver.observe(event.target);
  }

  /**
   * Scroll to the item with the corresponding ID
   *
   * @param id     the ID of the item you want to scroll to
   * @param offset adjustment relative to the header if it necessary
   */
  scroll(id: string, offset: number = 0) {
    const element = document.getElementById(id);

    if (element) {
      const y = element.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }
}
